import { render } from "./SchoolBoards.vue?vue&type=template&id=6032b6c4&scoped=true"
import script from "./SchoolBoards.vue?vue&type=script&lang=js"
export * from "./SchoolBoards.vue?vue&type=script&lang=js"

import "./SchoolBoards.vue?vue&type=style&index=0&id=6032b6c4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6032b6c4"]])

export default __exports__